<template>
    <UTooltip :text="showError? 'Pris må angis' : ''">
        <UInput
            v-model="unitPrice"
            type="number"
            size="sm"
            placeholder="Pris"
            data-cy="invoice-creator-unit-price"
            autocomplete="off"
            :disabled="disabled"
            :ui="{base: 'spinnerless text-right'}"
            :color="showError ? 'error': 'neutral'"
            :highlight="showError"
            @keydown.up.stop.prevent
            @keydown.down.stop.prevent
            @blur="touched = true"
        />
    </UTooltip>
</template>
<script setup lang="ts">
import {computed, ref} from 'vue'

const unitPrice = defineModel<number>('modelValue', {required: true})
defineProps({
    disabled: {type: Boolean, default: false}
})

const touched = ref(false)

const unitPriceValid = computed(() => {
    return Math.abs(unitPrice.value) > 0
})

const showError = computed(() => {
    return touched.value && !unitPriceValid.value
})
</script>